import { Select } from "antd";
import styled from "styled-components";
import useGetComponentes from "../hooks/useGetComponentes";

interface ComponenteSelectProps {
  id: string;
  recursos: any[];
  unidadeIdExterno: string;
  onChange: (idExterno: string) => void;
  onSearch?: (searchText: string) => void;
  searchComponent: Record<number, string>,
  index: number;
}

function ComponenteSelect({ id, recursos, unidadeIdExterno, onChange, onSearch, searchComponent, index, ...props }: ComponenteSelectProps) {
  const { data, isLoading } = useGetComponentes(unidadeIdExterno);

  const options = data?.map((item: any) => ({
    ...item,
    disabled: recursos?.some(r => r?.componenteIdExterno === item?.value),
  }));

  return (
    <StyledSelect
      showSearch
      onSearch={onSearch}
      onInputKeyDown={(e) => {
        if (e.key === "Tab") {
          const searchText = searchComponent[index]?.toLowerCase()?.trim();

          if (!searchText) return;

          const filteredOptions =
            options
              ?.filter((option: any) =>
                option.text?.toLowerCase().includes(searchText)
              ) || [];
          if (filteredOptions.length === 1) {
            const onlyMatch = filteredOptions[0];
            onChange(onlyMatch.value as string)
          }
        }
      }}
      {...props}
      optionFilterProp="text"
      size="large"
      placeholder="Selecione o componente"
      value={id}
      onChange={e => {
        onChange(e as string)
      }}
      options={options}
      loading={isLoading}
      disabled={isLoading}
      fieldNames={{ label: "text", value: "value" }}
    />
  );
}

const StyledSelect = styled(Select)`
  width: 100%;
  
  .ant-select-selector {
    border-radius: 10px !important;
  }
`;

export default ComponenteSelect;
